const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class CtaHoverCardCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    // Read data-size from the custom element
    const size = this.dataset.size

    // Decide breakpoint
    const disableAt = size === '2' ? 768 : 901

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 10,
        },
        breakpoints: {
          [`(min-width: ${disableAt}px)`]: {
            disabled: true,
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('cta-hover-card-carousel')) {
  customElements.define('cta-hover-card-carousel', CtaHoverCardCarousel)
}
